import React from 'react';
import { getClassNames } from 'js/utils/classNames.util';

import style from './Icon.scss';

export const Icon = ({ type = '', className = '', disabled = false, Tag = 'span', onClick, ...other }) => {
    const CurrentTag = onClick ? 'button' : Tag;

    return (
        <CurrentTag
            className={getClassNames([
                style.common,
                disabled && style.disabled,
                type && getClassNames([style.icon, style[type]]),
                className
            ])}
            onClick={onClick}
            {...other}
        />
    );
};
